import React from 'react';

import { Trash, Pencil, X, Help, Plus, Check } from '@ovpn-ui/icons';
import { IconButton as IconButton0, IconButtonProps } from '@ovpn-ui/core';

type IconButtonProxyProps = {
    content?: any;
    tooltip?: any;
    placement?: any;
    tooltipProps?: any;
} & IconButtonProps<'button'>;

/**
 * @deprecated
 */
function IconButton({ tooltip, content, ...iconButtonProps }: IconButtonProxyProps) {
    return (
        <IconButton0
            size="sm"
            variant="ghost"
            {...(iconButtonProps as IconButtonProps<'button'>)}
            aria-label={tooltip}
        >
            {content}
        </IconButton0>
    );
}

type IconButtonComponent = typeof IconButton;

function createVariant(Icon: typeof X): IconButtonComponent {
    return function VariantIB(props: IconButtonProxyProps) {
        return <IconButton {...props} content={(<Icon />) as any} />;
    };
}

/**
 * @deprecated
 */
export default Object.assign(IconButton, {
    Check: createVariant(Check),
    Help: createVariant(Help),
    Pencil: createVariant(Pencil),
    Plus: createVariant(Plus),
    Trash: createVariant(Trash),
    X: createVariant(X),
});
